export const pt_pt = {

    BarMenu: {
        Home: "Inicio",
        Sell: "Vender",
        Buy: "Comprar",
        Rent: "Arrendar",
        Account: "Minha Conta",
        Languages: "Linguas",
        Login: "Entrar",
        Logout: "Sair",
        Credentials: "Credencias",
        MyProduct: "Meus Produtos",
        Product: "Produtos",
        Add: "Adicionar",
        List: "Listar",
        Categories: "Categorias",
        Categorie: "Categoria",
        Agents: "Agentes",
        Profile: "Perfil",
        Agent: "Agente",
        ProporsalClients: 'Propostas',
        agence: 'Agencia',
        franchise: 'Franquia',
        BecomeAgent: "Seja um agente",
        ListProductAvailabe: 'Produtos Disponiveis',
        Candidate: 'Candidaturas',
        beAgent: 'Quero ser agente',
        Contact: "Fale conosco",
        RealEstate: "Imóveis",
        Type: "Tipo",
        BuyRentProperty: "Comprar/Arrendar"






    },

    FormLogin: {
        ForgotPassword: "Esqueceu a senha",
        ShowPassword: "Mostrar Senha",
        RemberMe: "Lembrar-me",
        Password: "Senha de pelo menos 8 dígitos, contendo maiúsculas, minúsculas e dígitos  ",
        AccessAccount: "Acesse a sua conta",
        SignUp: "Ainda não tem uma conta",
        clickTitle: "Clique Aqui",
        Access: "Entrar",
        Proceed: "Proceder",
        Processing: "Processando",
        Email: "Email",
        PasswordLabel: "Senha",
        Name: "Nome",
        Contact: "Contacto",
        Accessing: "Entrando",
        recoverEmail: "Recuperar sua senha",
        update: "Actualizar",
        updating: "Actualizando...",
        LoginGoogle: "Entrar com Google",
        Or: "Ou",

    },

    HomePage: {
        Featured: "Em Destaque",
        FindYourProduct: "Encontre o seu produto",
        RealState: "Comprar",
        Land: "Arrendar",
        News: "Novidades",
        Popular: "Mais Vistos",
        SearchProductLabel: 'Onde?',
        Buy: "A Venda",
        Rent: "Aluguer",
        SearchProductInput: 'Informe a Província, Distrito onde deseja comprar ou alugar seu imóvel...',
        Searching: "Pesquisando",
        NoResults: "Nenhum Resultado Encontrado",
        RealEstate: "Imóvel",


    },


    Footer: {
        aboutSite: "Procura arrendar, comprar uma casa ou trespassar um espaço? Nós somos a solução ideal para si!",
        Resources: "Recursos",
        Links: {
            Home: "Inicio",
            ProductDateils: "Detalhes do Produto",
            Agents: "Agentes",
            ContactUs: "Contacte-nos",
            HelpUs: "Ajude-nos a melhorar a plateforma"
        },
        MyAccount: {
            WhyTransapss: "Porque - Terrenos Transpasse",
            Contacts: "Contactos",
            PolicePrivicy: "Politica Privacidade",
            AcessYouData: "Acesso ao seus dados pessoas",
            PrivacyState: "Declaracao de Privacidade",
            CondOfUse: "Condicoes de uso",
            SafetyTips: "Dicas de Seguranca",
            Newsletter: "Boletim Informativo",
            KeepInformed: "Queremos te mater informado das nossas novidades inscreva-te",
            YourEmail: "Seu Email",
            SignUp: "Inscreva-te",
            FallowUs: "Siga-nos",
            MyAccount: "Minha Conta"

        }
    },

    PageDateils: {
        Description: "Descrições",
        Dateils: "Detalhes",
        Divisions: "Divisões",
        Maps: 'Mapa',
        ContactAgent: "Contactar Agente",
        Comment: "Comentários",
        Proposal: "Proposta",
        Share: "Partilhar",
        Bedroom: "Quartos",
        Lift: "Elevador",
        Parking: "Parque",
        ProductAvailableRent: "Aluguer",
        ProductAvailableSell: "Venda"
    },


    PageFilter: {
        InfoStatusMessage: "Não há imóveis que obedeçam ao seu critério de procura!",
        InfoMessageSmall: "Por favor tente uma nova pesquisa.",
        InfoAction: "Se preferir, você pode requisitar um imóvel para compra ou requisitar um imóvel para aluguel, e nós notificaremos você caso algum imóvel que atenda ao seu perfil fique disponível.",
        FilterBtnText: "Filtros",
        ServiceBtnText: "Serviço P",
        Price: "Preço",
        PriceMin: "Preço Mínimo",
        PriceMax: "Preço Máximo",
        Location: "Localização",
        DefineIntervalPrice: "Defina o seu intervalo de preços",
        BtnAply: "Aplicar",
        BtnRent: "Aluguer",
        MoreFilterTitle: "Mais Filtros",
        SeeMoreTitle: "Ver Mais",
        WcLabel: "Casas de Banho",
        AreaLabel: "Área m2",
        Lift: "Elevador",
        MarketState: "Estado do Mercado",
        CategorieRealEstate: "Categoria do Imóvel",
        Published: "Publicado",
        ServicePersonalized: "Serviços Personalizado",
        ProductCategorie: "Categoria do Produto",
        RentOrBuy: "Aluguer/Comprar",
        Title: "Título",
        district: "Selecione Distrito",
        ProvinceLabel: "Selecione Provincia",
        MarketStateLabel: "Selecione Estado  do Mercado",
        PlaceHolderCategorie: "Por Favor Selecione a Categoria",
        PlaceHolderCategorieRentOrBuy: "Por Favor Selecione se Deseja Alugar/Comprar",
        PlaceHolderContact: "Informe Seu Contacto",
        PlaceHolderEmail: "Informe Seu Email",
        Loading: "Carregando mais Produtos",
        Any: "Qualquer",
        DescriptionP: "Por Favor Deixe sua Descrição aqui, menciona tambem as infra-estruturas mais próximas que deseja para facilitar os nossos agentes...",
        Send: "Enviar",
        Cancel: "Cancelar",
        CleanTitle: "Limpar",
        Description: "Descrição",
        SelectTime: "Por Favor Selecione o Tempo",
        SortBy: "Ordenar Por",
        Default: "Padrão",
        PriceLowToHigh: "Preço (Baixo para Alto)",
        PriceHighToLow: "Preço (Alto para Baixo)",
        MostViewed: "Mais Vistos",
        Newest: "Mais Recentes",
        Oldest: "Mais Antigos",
        FindResult: "Anúncios encontrados",
        Search: "Pesquisar",
        SearchByTitle: "Pesquisar por titulo",
        PriceRange: "Intervalo de Preço",
        Filter: "Filtrar",
        Reset: "Limpar",
        Type: "Tipo",
        Types: "Tipos",
        Category: "Categoria",
        Categories: "Categorias",
        Proposity: "O que deseja?",
        ApplyFilters: "Aplicar Filtros",

    },

    AdminDashBoard: {
        TotalProduct: "Total Produtos",
        TotalAgents: "Total Agentes",
        ProductSell: "Produtos Vendidos",
        ProductRent: "Produtos Aluguer",
        Sell: "Vendas",
        Rent: "Aluguer",
        LastFiveProducts: "Últimos 5 Produtos",
        Type: "Tipo",
        Categorie: "Categoria",
        Available: "Disponivel",
        Date: "Data",
        Province: "Provincia",
        District: "Distrito",
        Neighborhood: "Bairro",
        DragAndDrop: "Arrastar e soltar imagem",
        DragAndDropAgent: "Arrastar e soltar imagem de perfil",
        DragAndDropPlaceholder: "Arrastar e Soltar a imagem aqui ou",
        DragAndDropPlaceholderAgent: "Arrastar e Soltar a imagem de perfil aqui ou",
        DragAndDropPlaceholderV: "Arrastar e soltar o video",
        DragAndDropPlaceholderVideo: "Arrastar e soltar o video aqui ou",
        Choose: "Escolha",
        Floor: "Piso",
        BuildYear: "Ano de construção",
        BruteArea: "Área Bruta*",
        Parking: "Estacionamento",
        Back: "Back",
        AreaLoteTotal: "Área Total do Lote",
        AreaUtil: "Área Útil",
        Submit: "Submeter",
        BruteAreaPrimitive: "Área Bruta Privativa",
        Next: "Próximo",
        Visits: "Visitas"



    },

    FormAgents: {
        Title: "Cadastrar Novo Agente",
        CompleteName: "Nome Completo",
        BirthDate: "Data de Nascimento",
        Gender: "Gênero",
        MaritalStatus: "Estado Civil",
        BI: "BI",
        AlternativeContact: "Contacto Alternativo*"
    },
    Geral: {
        Type: "Tipo",

        Sell: "Vender",
        Buy: "Comprar",
        Rent: "Arrendar",
    },

    "Dashboard": "Painel de Controle",
    "Products": "Publicações",
    "Subscription": "Subscrição",
    "Profile": "Perfil",
    "Account": "Conta",
    "Notifications": "Notificações",
    "Settings": "Configurações",
    "Logout": "Sair",
    "Balance": "Saldo",
    "Moviments": "Movimentos",
    "Amount": "Valor",
    "Contact": "Contacto",
    "Payment Method": "Método de Pagamento",
    "Payment Data": "Dados de Pagamento",
    "Available balance": "Saldo Disponível",
    "Withdraw": "Levantar",
    "Deposit": "Depositar",
    "Recharge": "Recarregar",
    "Processing": "Processando",
    "Recharge wallet": "Recarregar Conta",
    "Payout with MPesa": "Levantar com MPesa",
    "Recharge with MPesa": "Recarregar com MPesa",
    "Submit": "Submeter",
    "phone": "Contacto",
    "mpesa_gateway_instructions": "Digite o seu número de telefone M-Pesa (84/85) e clique em 'Recarregar', e depois confirme o pin no seu telefone.",
    "Number of Days": "Número de Dias",
    "Cost per Day": "Custo por Dia",
    "Discount Applied": "Disconto Aplicado",
    "Total Cost": "Custo Total",
    "Final Cost": "Custo Final",
    "Product subscription": "Subscrição de Produto",
    "New Request notification": "Nova Notificação de Pedido",
    "No Products Found": "Nenhum Produto Encontrado",

    "Agents": "Agentes",
    "Proporsal Clients": "Propostas",
    "Candidate": "Candidaturas",
    "Be Agent": "Seja um agente",
    "Reviews": "Avaliações",
    "Ratings": "Classificações",
    "Rating": "Classificação",
    "Review this property": "Avalie este imóvel",
    "Give your opinion about this property": "Dê a sua opinião sobre este imóvel",
    "write a review": "escreva uma avaliação",
    "write a review/comment": "escreva uma avaliação/comentário",
    "Write a comment": "Escreva um comentário",
    "Add a Comment": "Adicionar um Comentário",
    "Post Comment": "Publicar Comentário",
    "Comments": "Comentários",
    "Load More": "Carregar Mais",
    "No comments yet": "Ainda não há comentários",
    "Reply": "Responder",
    "Delete": "Apagar",
    "Replies": "Respostas",
    "You need to be logged in to comment": "Você precisa estar logado para comentar",
    "Please log in to add your comment.": "Por favor, faça login para adicionar seu comentário.",
    "Please log in to add your reply.": "Por favor, faça login para adicionar sua resposta.",
    "You need to be logged in to reply": "Você precisa estar logado para responder",

    "warning": "aviso",
    "Log In": "Entrar",
    "Cancel": "Cancelar",
    "Comment content is required.": "O conteúdo do comentário é obrigatório.",
    "Create New Account": "Criar Nova Conta",
    "Agent": "Agente",
    "Register": "Registar",
    "Proceed": "Proceder",
    "Actions Logs": "Registos de Ações",
    "Contact Messages": "Mensagens de Contacto",
    "pending": "pendente",
    "approved": "aprovado",
    "rejected": "rejeitado",
    "disapproved": "desaprovado",
    "Recharge Account": "Recarregar Conta",
    "Request Property": "Solicitar Imóvel",
    "Publish Property": "Publicar Imóvel",
    "Privacy Policy": "Política de Privacidade",
    "Terms & Conditions": "Termos e Condições",
    "About Us": "Sobre Nós",
    "About": "Sobre",
    "All Rights Reserved": "Todos os direitos reservados",
    "Submitting": "Submetendo",
    "Submiting": "Submetendo",
    "Select properties": "Selecione imóveis",
    "Gym": "Ginásio",
    "Pool": "Piscina",
    "Garden": "Jardim",
    "AI Analysis": "Análise com IA",
    
    "PaymentReports.completed": "Concluído",
    "PaymentReports.pending": "Pendente",
    "PaymentReports.failed": "Falhou", 
    "PaymentReports.cancelled": "Cancelado",
    "PaymentReports.PaymentsByProvider": "Pagamentos por Provedor",
    "PaymentReports.NumberOfPayments": "Número de Pagamentos",
    "PaymentReports.TotalAmount": "Montante Total (MZN)",
    "PaymentReports.PaymentStatusDistribution": "Distribuição de Estado de Pagamentos",
    "PaymentReports.PaymentProviderDistribution": "Distribuição de Provedores de Pagamento",
    "PaymentReports.DailyPayments": "Pagamentos Diários",
    "PaymentReports.ReportsAndStatistics": "Relatórios de Pagamentos & Estatísticas",
    "PaymentReports.TotalPayments": "Total de Pagamentos",
    "PaymentReports.TotalTransactions": "Total de Transações",
    "PaymentReports.ActiveWallets": "Carteiras Ativas",
    "PaymentReports.Filters": "Filtros",
    "PaymentReports.DateFrom": "Data De",
    "PaymentReports.DateTo": "Data Até",
    "PaymentReports.Status": "Estado",
    "PaymentReports.AllStatuses": "Todos os Estados",
    "PaymentReports.Provider": "Provedor",
    "PaymentReports.AllProviders": "Todos os Provedores",
    "PaymentReports.TransactionType": "Tipo de Transação",
    "PaymentReports.AllTypes": "Todos os Tipos",
    "PaymentReports.Credit": "Crédito",
    "PaymentReports.Debit": "Débito",
    "PaymentReports.Payments": "Pagamentos",
    "PaymentReports.Transactions": "Transações",
    "PaymentReports.Charts": "Gráficos",
    "PaymentReports.PaymentList": "Lista de Pagamentos",
    "PaymentReports.Loading": "Carregando...",
    "PaymentReports.NoPaymentsFound": "Nenhum pagamento encontrado.",
    "PaymentReports.User": "Utilizador",
    "PaymentReports.Amount": "Valor",
    "PaymentReports.Reference": "Referência",
    "PaymentReports.Date": "Data",
    "PaymentReports.Showing": "Mostrando",
    "PaymentReports.To": "até",
    "PaymentReports.Of": "de",
    "PaymentReports.Entries": "registros",
    "PaymentReports.TransactionList": "Lista de Transações",
    "PaymentReports.NoTransactionsFound": "Nenhuma transação encontrada.",
    "PaymentReports.Balance": "Saldo",
    "PaymentReports.Type": "Tipo",
    "PaymentReports.Description": "Descrição",
    "PaymentReports.ChartsAndAnalytics": "Gráficos e Análises",
    "PaymentReports.LoadingChart": "Carregando gráfico..."
}